export const email = "soporte@alliance-cloud.com";
export const phone = {
  number: "+582612011132",
  mask: "(+58) 261 2011132"
};
